// Register.js

import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Container, Square } from "./styles";
import ButtonGreen from "../../components/ButtonGreen/ButtonGreen";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import api from "../../services/api";

const Register = () => {
  const [stores, setStores] = useState([]);
  const [leroyCode, setLeroyCode] = useState("");
  const [storeBusinessUnitCode, setStoreBusinessUnitCode] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isManager, setIsManager] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const [selection, setSelection] = useState("");

  const handleSelectChange = (value) => {
    setSelection(value);
    setStoreBusinessUnitCode(value);
  };

  const handleSelectIsManager = (value) => {
    setIsManager(value);
  };

  const formatPhoneNumber = (value) => {
    // Remove todos os caracteres não numéricos
    const numericValue = value.replace(/[^0-9]/g, "");

    // Verifique o comprimento do número de celular
    if (numericValue.length <= 2) {
      // Formato: (XX
      return `(${numericValue}`;
    } else if (numericValue.length <= 6) {
      // Formato: (XX) XXXX
      const firstPart = numericValue.slice(0, 2);
      const secondPart = numericValue.slice(2);
      return `(${firstPart}) ${secondPart}`;
    } else if (numericValue.length <= 10) {
      // Formato: (XX) XXXX-XXXX
      const firstPart = numericValue.slice(0, 2);
      const secondPart = numericValue.slice(2, 6);
      const thirdPart = numericValue.slice(6);
      return `(${firstPart}) ${secondPart}-${thirdPart}`;
    } else {
      // Mantém apenas os primeiros 11 dígitos
      return numericValue.slice(0, 11);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = {
        leroy_code: leroyCode,
        store_business_unit_code: storeBusinessUnitCode,
        name: name,
        phone_number: phoneNumber,
        is_manager: isManager,
        email: email,
        password: password,
      };

      if (
        !leroyCode ||
        !storeBusinessUnitCode ||
        !name ||
        !phoneNumber ||
        !isManager ||
        !email ||
        !password
      ) {
        toast.error("Por favor preencha todos os campos");
        return;
      }

      api
        .post("/employees", data)
        .then((response) => {
          console.log(response.data);
          toast.success("Funcionário cadastrado com sucesso!");
          navigate("/login");
        })
        .catch((error) => {
          console.log(data);
          toast.error(`${JSON.parse(error.request.response).message}`);
          console.log(
            "err.message",
            JSON.parse(error.request.response).message
          );
        });
    } catch (err) {
      if (err instanceof Error) {
        toast.error(`${JSON.parse(err.request.response).message}`);
        console.log("err.message", JSON.parse(err.request.response).message);
      }
    }
  };

  useState(() => {
    api.get("/stores").then((response) => {
      setStores(response.data);
    });
  }, []);

  return (
    <>
      <ToastContainer />
      <Container>
        <MDBRow style={{ width: "50%" }}>
          <MDBCol
            lg="12"
            className="text-start"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Square>
              {/* Forms de email e senha*/}
              <form onSubmit={handleSubmit}>
                <h6>LDAP</h6>
                <Input
                  type="text"
                  autoComplete="leroyCode"
                  name="leroyCode"
                  value={leroyCode || ""}
                  onChange={(event) => setLeroyCode(event.target.value)}
                />
                <h6>Loja</h6>
                <Select
                  label="Selecione uma loja"
                  options={stores.map((option) => ({
                    value: option.business_unit_code,
                    label: option.location,
                  }))}
                  selection={selection}
                  onChange={handleSelectChange}
                />
                <h6>Nome</h6>
                <Input
                  type="text"
                  autoComplete="name"
                  name="name"
                  value={name || ""}
                  onChange={(event) => setName(event.target.value)}
                />
                <h6>Celular</h6>
                <Input
                  type="text"
                  autoComplete="phoneNumber"
                  name="phoneNumber"
                  placeholder="(XX) XXXX-XXXX"
                  value={phoneNumber || ""}
                  onChange={(event) =>
                    setPhoneNumber(formatPhoneNumber(event.target.value))
                  }
                />
                <h6>É gerente?</h6>
                <Select
                  label="Selecione"
                  options={[
                    { value: "True", label: "Sim" },
                    { value: "False", label: "Não" },
                  ]}
                  selection={isManager}
                  onChange={handleSelectIsManager}
                />
                <h6>E-mail</h6>
                <Input
                  type="text"
                  autoComplete="email"
                  name="email"
                  value={email || ""}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <h6>Senha</h6>
                <Input
                  type="password"
                  autoComplete="current-password"
                  name="senha"
                  value={password || ""}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <MDBRow>
                  <MDBCol>
                    <ButtonGreen type="submit" label="Registrar" />
                  </MDBCol>
                </MDBRow>
              </form>
            </Square>
          </MDBCol>
        </MDBRow>
      </Container>
    </>
  );
};

export default Register;
